import React from 'react';

export const languageContext = React.createContext();
